/* fail-safe */try{
/* Proactive Coaching — GA4 event wiring (gtag itself loads in default.hbs
 * with send_page_view:false; THIS file emits the labeled page_view).
 *
 * Event names are LOCKED by the GEO spec (S8c) — don't improvise:
 *   page_view        every page, content_group = pcPageType()
 *   signup_open      membership portal signup opened
 *   sign_up_complete portal success hash (best-effort; Ghost/Stripe is truth)
 *   checkout_start   buy.stripe.com payment-link click (none on site yet —
 *                    matcher is live so the event starts the day one ships)
 *   paywall_view     preview cut-off scrolled into view ([data-paywall],
 *                    set in partials/reader.hbs on every gate variant)
 *   cta_click        ask_bruce / speaking / testimonials links
 * Legacy commerce events kept: buy_button_click, school_membership.
 * (membership_signup was renamed sign_up_complete 2026-08-06, GEO spec.)
 *
 * page_type comes from Ghost body classes, so tagging posts correctly is
 * what labels analytics correctly — qa posts carry tag `qa`, library posts
 * carry booklet/video/podcast/article.
 */
(function () {
    var SHOP_HOST = 'shop.proactivecoaching.ai';
    var LEGACY_HOST = '1fibpq-yu.myshopify.com';

    function track() {
        if (typeof window.gtag === 'function') window.gtag.apply(null, arguments);
    }

    function pcPageType() {
        var c = (document.body && document.body.className) || '';
        if (c.indexOf('tag-qa') > -1) return 'qa_post';
        if (/\btag-(booklet|video|podcast|article)\b/.test(c)) return 'library_post';
        if (c.indexOf('post-template') > -1) return 'post_other';
        if (c.indexOf('home-template') > -1) return 'home';
        if (c.indexOf('page-template') > -1) return 'page';
        return 'other';
    }
    function base() {
        return { page_type: pcPageType(), post_path: location.pathname };
    }
    /* WHERE a CTA was clicked. Without this, a footer housekeeping link and a
       hero button land in GA4 as the same cta value, so no CTA on the site has
       a trustworthy click-through number. */
    function placement(a) {
        if (!a || !a.closest) return 'body';
        if (a.closest('#pc-footer')) return 'footer';
        if (a.closest('#pc-topbar, #pc-tb-panel')) return 'nav';
        if (a.closest('.pcb-gate, .pcb-lock')) return 'gate';
        return 'body';
    }

    // 0. Labeled page_view — content_group segments all standard reports.
    //    (gtag config in default.hbs sets send_page_view:false.)
    track('event', 'page_view', { content_group: pcPageType() });

    // 1. Legacy buy links -> branded store domain
    document.querySelectorAll('a[href*="' + LEGACY_HOST + '/products/"]').forEach(function (a) {
        a.href = 'https://' + SHOP_HOST + a.pathname + a.search;
    });

    // 2. Funnel + CTA + commerce clicks — one delegated listener, capture
    //    phase so it fires before navigation.
    document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest && e.target.closest('a');
        if (!a) return;
        var href = a.getAttribute('href') || '';

        // Commerce (legacy, kept): store buy links. /cart/ too — the Complete
        // Booklet Collection's fallback is a cart permalink (straight to
        // checkout), not a /products/ page; the host check keeps this scoped
        // to the shop.
        if (/\/(products|cart)\//.test(href) || /\/cart(\/|\?|$)/.test(href)) {
            var host = a.host || '';
            if (host === SHOP_HOST || host.indexOf('myshopify.com') > -1 || host === 'proactivecoaching.info') {
                var m = a.pathname.match(/\/products\/([^/?#]+)/);
                var mount = a.closest('[data-pc-buy]');
                track('event', 'buy_button_click', {
                    booklet: (mount && mount.getAttribute('data-handle')) || (m && m[1]) || 'unknown'
                });
            }
        }

        // GEO funnel + CTA events
        if (href.indexOf('#/portal/signup') > -1) {
            track('event', 'signup_open', base());
        } else if (href.indexOf('#/portal') > -1) {
            track('event', 'portal_open', base());
        } else if (href.indexOf('buy.stripe.com') > -1) {
            track('event', 'checkout_start',
                Object.assign({ product: 'school_membership' }, base()));
        } else if ((a.pathname || '').indexOf('/ask') === 0) {
            /* Was '/ask-bruce', which matched almost NOTHING: the site has 48
               links to /ask/ and effectively none to /ask-bruce/, so the
               flagship feature's CTA clicks went uncounted (2026-08-08 audit).
               Prefix on pathname covers /ask/ and /ask-bruce/ both. */
            track('event', 'cta_click', Object.assign({ cta: 'ask_bruce', placement: placement(a) }, base()));
        } else if (href.indexOf('/book-a-speaker') > -1) {
            track('event', 'cta_click', Object.assign({ cta: 'speaking', placement: placement(a) }, base()));
        } else if (href.indexOf('/testimonials') > -1) {
            track('event', 'cta_click', Object.assign({ cta: 'testimonials', placement: placement(a) }, base()));
        } else if (/\/pricing\/?($|[?#])/.test(href)) {
            /* The gate's second line ("See what membership includes") and every
               pricing link. Untracked until 2026-08-08, which meant the choice
               between "start the trial" and "check the price first" — the most
               interesting fork on a locked page — was invisible. */
            track('event', 'cta_click', Object.assign({ cta: 'pricing', placement: placement(a) }, base()));
        } else if (/\/library\/?($|[?#])/.test(href)) {
            track('event', 'cta_click', Object.assign({ cta: 'library', placement: placement(a) }, base()));
        }
    }, true);

    // 2b. 404s that REAL people hit. Ghost's 404 carries no distinguishing body
    //     class, so key off the rendered error markup instead. referrer is the
    //     whole point: it names what linked to the dead URL.
    if (document.querySelector('.error-content, .pcb-404, [data-error-404]')
        || /^404\b/.test((document.title || '').trim())) {
        track('event', 'page_not_found', {
            post_path: location.pathname,
            referrer: document.referrer || '(none)'
        });
    }

    // 3. sign_up_complete — Portal success is a hash route, not a page load.
    //    Best-effort by design: paid-conversion truth is Ghost/Stripe.
    function portalCheck() {
        var h = location.hash || '';
        if (h.indexOf('/portal/signup/success') === -1 && h.indexOf('/portal/success') === -1
            && location.search.indexOf('success=true') === -1) return;
        if (sessionStorage.getItem('pc-ga-signup')) return; // once per session
        sessionStorage.setItem('pc-ga-signup', '1');
        track('event', 'sign_up_complete', { page_type: pcPageType(), product: 'membership' });
    }
    window.addEventListener('hashchange', portalCheck);
    portalCheck();

    // 4. school_membership (legacy, kept) — Stripe school checkout lands here
    if (location.pathname.replace(/\/+$/, '') === '/school-welcome') {
        track('event', 'school_membership');
    }

    // 5. paywall_view — once, when the preview cut-off scrolls into view.
    var gate = document.querySelector('[data-paywall]');
    if (gate && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries, obs) {
            entries.forEach(function (en) {
                if (en.isIntersecting) {
                    track('event', 'paywall_view', base());
                    obs.disconnect();
                }
            });
        }, { threshold: 0.5 }).observe(gate);
    }
})();

}catch(e){/* analytics must never halt the bundle */}
